<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="payGatewayDialogForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3" *ngIf="isSubmitButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            Payment Gateway
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Add Payment Gateway
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="isEditButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            Payment Gateway
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Update Payment Gateway
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>Gateway name</mat-label>
                                <mat-select formControlName="gatewayName" placeholder="Select Payment Gateway">
                                    <mat-option *ngFor="let item of gatewayList" [value]="item" >
                                        {{item}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div> -->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Gateway Name</mat-label>
                                    <input onkeydown="return (event.keyCode!=13);" [readonly]="isRead"
                                     class="color" matInput formControlName="gatewayName"
                                        placeholder="Gateway Name" required>
                                    <mat-error class="margin_tp"
                                        *ngIf="payGatewayDialogForm.controls['gatewayName'].touched && payGatewayDialogForm.controls['gatewayName'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="payGatewayDialogForm.controls['gatewayName'].touched && payGatewayDialogForm.controls['gatewayName'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                          <div class="">
                            <div class="row">
                              <div class="col-sm-3 mt-3">
                                <mat-label class="mt-1 lclass"><span
                                    class="required-asterisk mr-1">Active</span>
                                </mat-label>
                              </div>
                              <div class="col-sm-7 mt-3">
                                <mat-radio-group onkeydown="return (event.keyCode!=13);"
                                  formControlName="isActive" class="example-full-width">
                                  <div class="row">
                                    <div class="col-sm-5">
                                      <mat-radio-button value='Y'>
                                       Yes
                                      </mat-radio-button>
                                    </div>
                                    <div class="col-sm-5">
                                      <mat-radio-button value='N'>
                                        No
                                      </mat-radio-button>
                                    </div>
                                  </div>
                                </mat-radio-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Save" type="button"  *ngIf="isSubmitButton" 
                            class="btn btn-primary btn-icon-text floatright mt-1"
                            (click)="submit()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button id="Save" type="button"  *ngIf="isEditButton" 
                            class="btn btn-primary btn-icon-text floatright mt-1"
                            (click)="update()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Edit
                            </span>
                        </button>
                        <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>